import { render, staticRenderFns } from "./AccountOff.vue?vue&type=template&id=2f189a32"
import script from "./AccountOff.vue?vue&type=script&lang=ts"
export * from "./AccountOff.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports